export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9813.b3799789.jpg";